module.exports = __webpack_public_path__ + "img/win_item5.fcc70b62.png";